import PropTypes from "prop-types";
import "./styles.css";

function UserList({ users, teamName }) {
  const names = users.map((user) => user.displayName).join(", ");

  return (
    <div className="cardEvent--namesWrapper">
      {users?.length ? (
        <div className="cardEvent--names">
          {teamName && `${teamName}: `}
          {names}
        </div>
      ) : (
        <div className="cardEvent--empty-title">
          {teamName ? `${teamName}: Empty` : "Be the first to join this group"}
        </div>
      )}
    </div>
  );
}

UserList.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number,
      map: PropTypes.func,
    }),
  ).isRequired,
  teamName: PropTypes.string,
};

UserList.defaultProps = {
  teamName: null,
};

export { UserList };
